import routes from './routes'
import localStore from './store'
import Base from '../Base'

export default class extends Base{
    name = "imports"
    routes = routes
    localStore = localStore

}